<template>

    <div class="padded">
      <div class="dash-heading"><i class="fa fa-globe" />&nbsp;Maintenance Summary</div><br />

      <op-stats :show-requests="false" />

      <ticket-summary />

      <events-calendar category="tickets" />

    </div>

</template>


<script>

import EventsCalendar from '@/components/atoms/EventsCalendar'

import OpStats from '@/components/dashboard/OpStats'
import TicketSummary from '@/components/dashboard/maintenance/TicketSummary'

export default {

  components: {
    EventsCalendar,
    OpStats,
    TicketSummary
  }

}
</script>



// WEBPACK FOOTER //
// MaintenanceSummary.vue?a7f4f124